import { NavLink } from "react-router-dom";
import { Home, BookOpen, ShoppingCart, User } from "lucide-react";
import { useCart } from "@/context/CartContext";

const items = [
  { to: "/", label: "Inicio", icon: Home, testid: "nav-home" },
  { to: "/catalogo", label: "Catálogo", icon: BookOpen, testid: "nav-catalog" },
  { to: "/carrito", label: "Carrito", icon: ShoppingCart, testid: "nav-cart" },
  { to: "/perfil", label: "Perfil", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
  const { count } = useCart();
  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      <div className="flex justify-around py-2">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testid}
            className={({ isActive }) =>
              `relative flex flex-col items-center gap-1 px-4 py-2 rounded-2xl transition-colors ${
                isActive ? "text-[#0A2A66]" : "text-slate-400"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className="relative">
                  <Icon size={22} strokeWidth={isActive ? 2.4 : 2} />
                  {to === "/carrito" && count > 0 && (
                    <span className="absolute -top-2 -right-3 bg-[#F5B914] text-[#0A2A66] text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center">
                      {count}
                    </span>
                  )}
                </div>
                <span className={`text-[11px] ${isActive ? "font-semibold" : "font-medium"}`}>{label}</span>
                {isActive && <span className="absolute -bottom-0 left-1/2 -translate-x-1/2 w-8 h-[3px] rounded-full bg-[#F5B914]" />}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
